import { css } from "lit";
export const componentUtilities = css `
    .icon {
        inline-size: 1em;
        block-size: 1em;
        flex: none;
    }

    .icon > svg {
        display: block;
        inline-size: 100%;
        block-size: 100%;
    }
`;
